import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO component using react-helmet-async
 * Provides dynamic meta tags, Open Graph, Twitter Cards, and canonical URLs
 */
const SEOHelmet = ({
  title = 'CitiTekPro | Custom Software Development & Digital Solutions in Minnesota',
  description = 'CitiTekPro provides custom software development, web development, mobile app development, SEO services, IT consulting, and business automation solutions for businesses in Minnesota, Minneapolis, and St. Paul.',
  keywords = 'custom software development Minnesota, web development Minneapolis, mobile app development, SEO services Minnesota, digital marketing, IT consulting, business automation, AI software development, MERN stack development, SaaS application development, custom CRM development, Minnesota software company, Twin Cities web development',
  canonicalUrl = 'https://cititekpro.com',
  ogImage = 'https://cititekpro.com/og-image.png',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  robots = 'index, follow',
  author = 'CitiTekPro',
  children
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="CitiTekPro" />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional SEO tags */}
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />

      {/* Geo Tags for Local SEO */}
      <meta name="geo.region" content="US-MN" />
      <meta name="geo.placename" content="Minnesota" />

      {/* Custom children for additional meta tags or JSON-LD */}
      {children}
    </Helmet>
  );
};

export default SEOHelmet;
